import React, { Component }  from 'react';

class Workflows extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			active: false, 
			loading: false,
			entity: false
		};
	}
	
	activate = (entity) => (e) => {
		this.setState({entity: entity})
	}
	
	cancel = () => {
		this.setState({entity: false,loading: false})
	}
	
	componentWillReceiveProps(nextProps) {
		if(this.state.loading) {
			this.cancel();
		}
	}
	render() {
		if (this.props.active) {	
			var entityList = []
				for (var entity of this.props.data.Entities) {
					entityList.push(
						<div className="dataRow"  key={entity.entity} onClick={this.activate(entity)}>
							<span style={{flex: '0 0 300px'}} >{entity.entity}</span>
							
							<span style={{flex: '1 0 20%', textAlign: 'center'}}>{'Values: (' + entity.values.length +')' }</span>
							<div style={{flex: '0 0 120px', cursor: 'pointer'}}>
								<div className="activeBox" data-active={entity.fuzzy_match} >
									<div className={entity.fuzzy_match ? "enabled" : "disabled"}></div>
								</div>
							</div>
	
						</div>
					)
				}
				
			var activeEntity = ""
			if (this.state.entity) {
				var values = []
				for(var val of this.state.entity.values){
					var syns = []
					for(var syn of val[val.type]){
						syns.push(
							<div key={syn}>{syn}</div>
						)
					}
					values.push(
						<div style={{border: '1px solid #2a6aa9', padding: '15px'}} key={val.value}>
							
							<div style={{textAlign: 'left', fontSize: '1.2em'}}>{val.value}</div>
							{syns}
						</div>
					)
				}
				
				activeEntity = (
					<div className="blackout" tabIndex="1" autoFocus>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}>X</div>
							<div>Viewing details for entity: </div>
							<div style={{fontSize: '1.3em'}}>{this.state.entity.entity}</div>
							
							<div style={{ paddingTop: '25px',display: 'flex', justifyContent: 'space-around'}}>
								<div >
									<div>Fuzzy Match</div>
									<div className="activeBox">
										<div className={this.state.entity.fuzzy_match ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>
							{values}
							
							<div className="error" style={{padding: '15px'}}>{this.state.error}</div>
							
							{this.state.loading ? <div className="loader"></div> : <div className="button"  onClick={this.cancel}>Confirm Entity</div>}
						</div>
					</div>
				)
			}
			return (
				<div className="viewContent" >
					<div className="dataHeaders">
						<span style={{flex: '0 0 300px', cursor: 'pointer'}} onClick={this.sort} data-sortBy="enabled">Entity Name</span>
						<span style={{flex: '1 0 20px', cursor: 'pointer', textAlign: 'center'	}} onClick={this.sort} data-sortBy="name">Number of Values</span>
						<span style={{flex: '0 0 180px', cursor: 'pointer'}} onClick={this.sort} data-sortBy="modified">Fuzzy Matching?</span>
					</div> 
					<div style={{overflow: 'auto', height: 'calc(100% - 85px)'}}>
						{entityList}
						{activeEntity}
					</div>
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

export default Workflows


// WEBPACK FOOTER //
// ./src/Views/Entities.js